var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"address-table"},[_c('table',[_c('thead',[_c('tr',[_vm._t("head")],2)]),_vm._v(" "),_c('tbody',[_vm._t("body")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }